import React from 'react'

export default class IconsMainNavGroups extends React.Component {
    render() {
        let className = 'icons-icon'

        return (
            <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                className={className}
                style={this.props.style}
            >
                <path
                    d='M12 14C12 12.5855 11.4381 11.229 10.4379 10.2288C9.43771 9.22859 8.08116 8.66669 6.66667 8.66669C5.25218 8.66669 3.89563 9.22859 2.89543 10.2288C1.89524 11.229 1.33334 12.5855 1.33334 14'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M6.66667 8.66667C8.50762 8.66667 10 7.17428 10 5.33333C10 3.49238 8.50762 2 6.66667 2C4.82572 2 3.33334 3.49238 3.33334 5.33333C3.33334 7.17428 4.82572 8.66667 6.66667 8.66667Z'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M14.6667 13.3333C14.6667 11.0867 13.3333 9.00001 12 8.00001C12.4383 7.67119 12.7887 7.2394 13.0204 6.74285C13.252 6.24631 13.3577 5.70032 13.328 5.15321C13.2983 4.6061 13.1343 4.07473 12.8503 3.60614C12.5664 3.13755 12.1713 2.74618 11.7 2.46667'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        )
    }
}
